/**
 * GullyLabs Column Height Sync
 * Desktop only (≥750px): Makes the left image column height
 * follow the right info column height. When accordions open/close,
 * the image section expands/shrinks to match. Hidden scrolling
 * is applied if images exceed the available height.
 */
(function () {
  'use strict';

  const DESKTOP_BP = 750;
  let rafId = null;

  function syncHeights() {
    if (window.innerWidth < DESKTOP_BP) {
      // On mobile, remove any inline styles so layout stays natural
      const mw = document.querySelector('.product__media-wrapper');
      if (mw) mw.style.removeProperty('max-height');
      return;
    }

    const infoWrapper = document.querySelector('.product__info-wrapper');
    const mediaWrapper = document.querySelector('.product__media-wrapper');

    if (!infoWrapper || !mediaWrapper) return;

    const infoHeight = infoWrapper.offsetHeight;

    if (infoHeight > 0) {
      mediaWrapper.style.maxHeight = infoHeight + 'px';
    }
  }

  function requestSync() {
    if (rafId) cancelAnimationFrame(rafId);
    rafId = requestAnimationFrame(syncHeights);
  }

  function init() {
    const infoWrapper = document.querySelector('.product__info-wrapper');
    const mediaWrapper = document.querySelector('.product__media-wrapper');

    if (!infoWrapper || !mediaWrapper) return;

    // Initial sync
    syncHeights();

    // ResizeObserver on the info column to catch accordion changes
    if (typeof ResizeObserver !== 'undefined') {
      const ro = new ResizeObserver(function () {
        requestSync();
      });
      ro.observe(infoWrapper);
    }

    // Listen for <details> toggle events (accordion open/close)
    const accordions = infoWrapper.querySelectorAll('details');
    accordions.forEach(function (detail) {
      detail.addEventListener('toggle', function () {
        requestSync();
      });
    });

    // Also listen for custom Liquid accordions (.gully-acc)
    const gullyAccordions = infoWrapper.querySelectorAll('.gully-acc');
    gullyAccordions.forEach(function (detail) {
      if (detail.tagName === 'DETAILS') {
        detail.addEventListener('toggle', function () {
          requestSync();
        });
      }
    });

    // Recalculate on window resize
    window.addEventListener('resize', function () {
      requestSync();
    });

    // Re-sync when images finish loading (they may change the natural height)
    const images = mediaWrapper.querySelectorAll('img');
    images.forEach(function (img) {
      if (!img.complete) {
        img.addEventListener('load', function () {
          requestSync();
        });
      }
    });

    // Also re-sync after a brief delay to catch any late layouts
    setTimeout(syncHeights, 500);
    setTimeout(syncHeights, 1500);
  }

  // Run on DOMContentLoaded or immediately if already loaded
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
